import React from 'react';
import { BigIcon, CenteredContainer, Description, Title, Wrapper } from '../StatusViews.styles';

export const AppealPending = () => {
  return (
    <Wrapper>
      <CenteredContainer>
        <BigIcon className="far fa-history" />
        <Title fontSize="h4" color="neutral">
          Your Account is Pending
        </Title>
        <Description>
          We&apos;re reviewing your additional documents and will notify you with next steps.
        </Description>
      </CenteredContainer>
    </Wrapper>
  );
};
